import script from "./EffectsCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EffectsCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./EffectsCarousel.vue?vue&type=style&index=0&id=5fe77008&lang=scss"

const __exports__ = script;

export default __exports__